import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic'; // @angular/material dep. - for gesture support
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import makeSentry from './sentry';

if (environment.production) {
  enableProdMode();
}

declare const BRANCH_NAME: string;
declare const BUILD_DATETIME: string;

if (process.env.NODE_ENV === 'production') {
  console.log('scheduler: ', BUILD_DATETIME, BRANCH_NAME);
}

makeSentry();

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch(err => console.error(err));
